import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgeProjectRoute: InvariantJiraRoute = {
	name: 'forge-spa-project',
	path: '/jira/:projectType(software|software/c|core)/projects/:projectKey/apps/:appId/:envId/:route?',
};
